export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/daniel-olahs-af300b6e21dff8e136aa4f4acdb8dd11.jpg";